// extracted by mini-css-extract-plugin
export default {"root":"_19wlw","content":"_1cGgF"};